import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseNotificationNumber } from "../_types/case-notification-number";

@Injectable({
    providedIn: 'root',
})
export class CasesNotificationsNumbersService extends Service<CaseNotificationNumber> {
    public override type = 'caseNotificationNumbers';
    public override url = 'attendance/caseNotificationNumbers';
}
